import React, { useState, useEffect } from "react";
import { Card, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Box } from "@mui/material";
import { ChromePicker } from "react-color";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import LogoutButton from "layouts/logout";
import { useNavigate } from "react-router-dom";
import api from "core/interceptors/api";
import Swal from "sweetalert2";

function ColorSelection() {
  const [color, setColor] = useState("#9AA8F4"); // Default fallback
  const [openDialog, setOpenDialog] = useState(false);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  // Fetch saved color on mount
  useEffect(() => {
    const fetchSavedColor = async () => {
      try {
        const response = await api.get("/admin/color"); // <-- your GET endpoint
        if (response.data?.color) {
          setColor(response.data.color); // set saved color
        }
      } catch (error) {
        console.error("Failed to fetch saved color", error);
      }
    };
    fetchSavedColor();
  }, []);

  const handleColorChange = (newColor) => {
    setColor(newColor.hex);
  };

  const handleSaveColor = async () => {
    setSaving(true);
    try {
      const response = await api.post("/admin/color", { color });
      if (response.data.status === 1) {
        Swal.fire("Success", "Color saved successfully!", "success");
        setOpenDialog(false);
      } else {
        Swal.fire("Error", response.data.message || "Failed to save color", "error");
      }
    } catch (error) {
      Swal.fire("Error", error.message || "Failed to save color", "error");
    }
    setSaving(false);
  };

  return (
    <DashboardLayout>
      <MDBox display="flex" justifyContent="flex-end" alignItems="center" p={2}>
        <LogoutButton onLogout={() => navigate("/login")} />
      </MDBox>
      <DashboardNavbar />

      <MDBox py={3}>
        <Card>
          <MDBox p={3}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12} sm={8}>
                <MDTypography variant="h5" fontWeight="medium">
                  App Background Color
                </MDTypography>
                <MDTypography variant="button" color="text">
                  Current app background color is shown below.  
                  You can update it anytime.
                </MDTypography>
                <Box
                  sx={{
                    width: 100,
                    height: 40,
                    backgroundColor: color,
                    borderRadius: 1,
                    border: "1px solid #ccc",
                    mt: 2,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <MDButton variant="gradient" color="info" onClick={() => setOpenDialog(true)}>
                  Change Color
                </MDButton>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>Select Color</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center" gap={2} p={3}>
            <ChromePicker color={color} onChangeComplete={handleColorChange} disableAlpha />
            <MDTypography>
              Selected Color: <span style={{ color, fontWeight: "bold" }}>{color}</span>
            </MDTypography>
            <Box
              sx={{
                width: 80,
                height: 80,
                backgroundColor: color,
                borderRadius: 2,
                border: "1px solid #ccc",
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <MDButton variant="outlined" color="secondary" onClick={() => setOpenDialog(false)}>
            Cancel
          </MDButton>
          <MDButton variant="gradient" color="success" onClick={handleSaveColor} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default ColorSelection;
